/**
 * Remove all empty values from an object
 * @param obj
 * @returns An object with all empty values removed
 */
export function removeEmpty(obj) {
   return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}